const slaType = {
  ARRIVAL_CUTOFF: 1,
  INDENT_CUTOFF: 2,
  INDENT_AUTO_CANCEL: 3,
  ACCEPTANCE_SLA: 4,
  DEPOT_WORKING_TIME_SLA: 5,
  REINDENT_ACCEPTANCE_SLA: 6,
  REINDENT_ARRIVAL_CUTOFF: 7,
};

const arrivalSlaBasedOn = {
  BY_CUTOFF_TIME: 1,
  BY_HOURS: 2,
};

const slaChargeType = {
  PERCENTAGE: 'PERCENTAGE',
  ABSOLUTE: 'ABSOLUTE',

};
module.exports = {
  slaType,
  arrivalSlaBasedOn,
  slaChargeType,
};
